import { BOOKINGS_APP_DEF_ID, BOOKINGS_CHECKOUT_SECTION_ID, BOOKINGS_FORM_SECTION_ID } from './consts';
const isRunningInIframe = () => {
  return !(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope);
};
const isBookingsSectionInstalled = (wixCodeApi, sectionId) => {
  if (isRunningInIframe()) {
    return new Promise(resolve => {
      // @ts-expect-error
      window.Wix.isAppSectionInstalled(sectionId, {
        appDefinitionId: BOOKINGS_APP_DEF_ID
      }, isInstalled => {
        resolve(isInstalled);
      });
    });
  }
  return Promise.resolve(wixCodeApi.site.isAppSectionInstalled({
    sectionId,
    appDefinitionId: BOOKINGS_APP_DEF_ID
  }));
};
export const isBookingFormInstalled = wixCodeApi => {
  return isBookingsSectionInstalled(wixCodeApi, BOOKINGS_FORM_SECTION_ID);
};
export const isBookCheckoutInstalled = wixCodeApi => {
  return isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CHECKOUT_SECTION_ID);
};
const getSectionUrlParams = wixCodeApi => {
  try {
    const params = {
      ...(getUrlQueryParams(wixCodeApi).appSectionParams ? JSON.parse(decodeURI(getUrlQueryParams(wixCodeApi).appSectionParams)) : {})
    };
    return params;
  } catch {
    return {};
  }
};
export const getUrlQueryParams = wixCodeApi => {
  return wixCodeApi.location.query;
};
export const getUrlQueryParamValue = (wixCodeApi, key) => {
  const params = {
    ...getSectionUrlParams(wixCodeApi),
    ...getUrlQueryParams(wixCodeApi)
  };
  return params[key];
};
//# sourceMappingURL=utils.js.map